import React, { useState } from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  width: 100%;
`;

const Selector = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Button = styled.a`
  display: block;
  text-align: center;
  padding: 23px 0px;
  width: 150px;
  height: 85px;
  font-size: 32px;
  border: 1px solid #e96159;
  cursor: pointer;
  &:hover {
    background: #f2e3e3;
  }
`;

const Data = styled.div`
  height: 85px;
  font-family: "Inter";
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 125%;
  text-align: center;
  letter-spacing: -0.01em;
  color: #e96159;
  width: 100%;
  padding: 35px 0px;
  border-top: 1px solid #e96159;
  border-bottom: 1px solid #e96159;
`;

// eslint-disable-next-line no-extend-native
Date.isLeapYear = function (year) {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
};

// eslint-disable-next-line no-extend-native
Date.getDaysInMonth = function (year, month) {
  return [
    31,
    Date.isLeapYear(year) ? 29 : 28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31,
  ][month];
};

// eslint-disable-next-line no-extend-native
Date.prototype.isLeapYear = function () {
  return Date.isLeapYear(this.getFullYear());
};

// eslint-disable-next-line no-extend-native
Date.prototype.getDaysInMonth = function () {
  return Date.getDaysInMonth(this.getFullYear(), this.getMonth());
};

// eslint-disable-next-line no-extend-native
Date.prototype.addMonths = function (value) {
  var n = this.getDate();
  this.setDate(1);
  this.setMonth(this.getMonth() + value);
  this.setDate(Math.min(n, this.getDaysInMonth()));
  return this;
};

export default function MonthPicker({ year, month, day, callback }) {
  const [date, setDate] = useState(new Date(year, month, day));

  // const monthToName = (month) => {
  //   let months = [
  //     "Janeiro",
  //     "Fevereiro",
  //     "Março",
  //     "Abril",
  //     "Maio",
  //     "Junho",
  //     "Julho",
  //     "Agosto",
  //     "Setembro",
  //     "Outubro",
  //     "Novembro",
  //     "Dezembro",
  //   ];
  //   return months[month];
  // };

  return (
    <Wrapper>
      <Selector>
        <Button
          onClick={() => {
            let newValue = date.addMonths(-1);
            if (newValue < new Date()) {
              newValue = new Date();
            }
            setDate(newValue);
            callback(newValue);
          }}
        >
          ◀
        </Button>
        <Data>Escolher outro mês</Data>
        <Button
          onClick={() => {
            let newValue = date.addMonths(1);
            setDate(newValue);
            callback(newValue);
          }}
        >
          ▶
        </Button>
      </Selector>
    </Wrapper>
  );
}
